import gql from 'graphql-tag';

import { bookTariff, user } from '../fragments';

export const getTariffs = gql`
    query Tariffs($filters: TariffsFiltersInput) {
        tariffs(filters: $filters) {
            ...TariffOutputFragment
        }
    }
    ${bookTariff}
`;

export const checkTokenExist = gql`
    query CheckTokenExist($confirmationToken: String!, $email: String!, $type: String!, $requestingEntity: String!) {
        checkTokenExist(
            confirmationToken: $confirmationToken
            email: $email
            type: $type
            requestingEntity: $requestingEntity
        ) {
            ...UserFragment
        }
    }
    ${user}
`;

export const checkWaitlistNotificationExist = gql`
    query CheckWaitlistNotificationExist($waitlistNotificationGraphQlId: String!) {
        checkWaitlistNotificationExist(waitlistNotificationGraphQlId: $waitlistNotificationGraphQlId) {
            success
        }
    }
`;
